import React from "react";
import "../App.css";
import { useNavigate } from "react-router-dom";

const Home = () => {
  const navigate = useNavigate();

  const firstpage = () => {
    navigate("/input");
  };

  return (
    <div className="flex justify-center">
      <div className="flex flex-col items-center">
        <div>
          <h1 className="text-3xl pt-8">Experiment 4 : AES Key Generation</h1>
        </div>
        <div className="pt-10">
          <h1>Instructions</h1>
        </div>
        <div class="instruction-box">
          <p>
          <strong>Welcome to Experiment 4: AES Key Generation Simulator!</strong> Transitioning from DES, delve into the Advanced Encryption Standard (AES) and its unique round key generation process.
          <br /><br />

→ Initiate by entering a sixteen-character string. The simulator promptly translates this into its corresponding hexa-decimal form, paving the way for the AES Key generation journey.
<br /><br />

→ Navigate with ease using the "next" and "previous" buttons provided. These will guide you through the intricate 10-round key expansion mechanism, shedding light on every minute detail.
<br /><br />

→ Gain insights into the core aspects of AES key expansion. By clicking the designated buttons, students can access static values for the S box and round constant, granting a clear perspective into the internal machinations of the key expansion process.
<br /><br />

→ The hexa-decimal data is rendered as a matrix, streamlining comprehension by circumventing the complexity of elongated sequences.
<br /><br />

→ As you traverse the rounds, the simulator elucidates keys 1 to k-1 calculations with their intermediate results. Your acumen will be tested when prompted to deduce the kth round expansion key. Achieve accuracy, and the simulator unveils the subsequent phases.
<br /><br />

→ Enhance your understanding with the Learning Component: a vivid Concept Example. This animated and simulated feature is equipped with a "Previous" button, ensuring you can review and reinforce your knowledge as many times as you wish.
<br /><br />

<strong>Note:</strong> A technical journal proves invaluable in this journey. Document insights, challenges, and questions to ensure a comprehensive grasp on AES key generation intricacies. Dive in and immerse yourself in the world of AES.
          </p>
        </div>
        <div class="button-holder">
          <div class="next-button" onClick={firstpage}>
            NEXT
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
